import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function SosyalKacinmaTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['sosyal-kacinma-testi']} />;
}
